import { Content, ServiceContentRequest } from './types';
import { FailureActionPayload } from 'store/errors/types';
import { createAsyncAction } from 'typesafe-actions';

export const getServiceContent = createAsyncAction(
  'GET_SERVICE_CONTENT_REQUEST',
  'GET_SERVICE_CONTENT_SUCCESS',
  'GET_SERVICE_CONTENT_FAILURE',
)<ServiceContentRequest, Content, FailureActionPayload>();
